(function () {

  const BASE_PRODUCT_HANDLE = 'chazz-x-case4you';

  const REQUIRED_ADDON_HANDLES = [
    'atsparus-vandeniui-telefono-deklas',
    'devia-belaide-garso-kolonele',
    'kelioninis-power-bank'
  ];

  const WARNING_ID = 'bundle-cart-warning';

  async function getCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    return response.json();
  }

  function cartHasBaseProduct(cart) {
    return cart.items.some(function (item) {
      return item.handle === BASE_PRODUCT_HANDLE;
    });
  }

  function cartHasRequiredAddon(cart) {
    return cart.items.some(function (item) {
      return REQUIRED_ADDON_HANDLES.includes(item.handle);
    });
  }

  function findCheckoutButtons() {
    return document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], .cart__checkout-button'
    );
  }

  function showWarning() {

    if (document.getElementById(WARNING_ID)) return;

    const warning = document.createElement('div');

    warning.id = WARNING_ID;

    warning.innerText =
      'Prie CHAZZ x Case4You rinkinio būtina pasirinkti bent vieną elektronikos produktą.';

    warning.style.background = '#fff3f0';
    warning.style.border = '1px solid #e84a1a';
    warning.style.color = '#111';
    warning.style.padding = '12px 14px';
    warning.style.borderRadius = '10px';
    warning.style.margin = '12px 0';
    warning.style.fontSize = '14px';
    warning.style.fontWeight = '600';

    const cartDrawer = document.querySelector(
      'cart-drawer, .cart-drawer, #CartDrawer, form[action="/cart"], main'
    );

    if (cartDrawer) {
      cartDrawer.prepend(warning);
    }
  }

  function removeWarning() {
    const warning = document.getElementById(WARNING_ID);

    if (warning) {
      warning.remove();
    }
  }

  function disableCheckoutButtons() {

    findCheckoutButtons().forEach(function (button) {

      button.disabled = true;
      button.style.opacity = '0.45';
      button.style.pointerEvents = 'none';

      button.setAttribute('data-bundle-disabled', 'true');

    });

  }

  function enableCheckoutButtons() {

    findCheckoutButtons().forEach(function (button) {

      if (button.getAttribute('data-bundle-disabled') === 'true') {

        button.disabled = false;
        button.style.opacity = '';
        button.style.pointerEvents = '';

        button.removeAttribute('data-bundle-disabled');

      }

    });

  }

  async function validateBundleCart() {

    const cart = await getCart();

    const hasBase = cartHasBaseProduct(cart);
    const hasAddon = cartHasRequiredAddon(cart);

    if (hasBase && !hasAddon) {

      disableCheckoutButtons();
      showWarning();

      return false;
    }

    enableCheckoutButtons();
    removeWarning();

    return true;
  }

  document.addEventListener(
    'click',
    async function (event) {

      const checkoutElement = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], .cart__checkout-button'
      );

      if (!checkoutElement) return;

      const isValid = await validateBundleCart();

      if (!isValid) {

        event.preventDefault();
        event.stopPropagation();

        alert(
          'Prie CHAZZ x Case4You rinkinio būtina pasirinkti bent vieną elektronikos produktą.'
        );

        return false;
      }

    },
    true
  );

  document.addEventListener(
    'submit',
    async function (event) {

      const form = event.target;

      if (!form || !form.action || !form.action.includes('/cart')) {
        return;
      }

      const isValid = await validateBundleCart();

      if (!isValid) {

        event.preventDefault();
        event.stopPropagation();

        alert(
          'Prie CHAZZ x Case4You rinkinio būtina pasirinkti bent vieną elektronikos produktą.'
        );

        return false;
      }

    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {

    validateBundleCart();

    setInterval(function () {
      validateBundleCart();
    }, 1500);

  });

})();